import { PromocodeViewModel } from '@common/model/billing/promocode/view';
import { PromocodeUsageStatus } from '@common/model/billing/promocode/usageStatus';
import { promocodeApi } from '../api';

/**
 * Activated but not wasted promocode
 */
export const useGetPromocodes = (): PromocodeViewModel[] => {
  const { data } = promocodeApi.endpoints.getPromocodesUsages.useQuery({ status: PromocodeUsageStatus.Activated });
  return data ?? [];
};
